import { connect } from 'react-redux'

import Filters from '../components/filters'

import { changeDisplayOptionFilter, changeTournament, changeCourseFilter, changeStartingHoleFilter, changeSortOption, changeSortOrderOption, changeRound, showHideFilters} from '../actions'

const mapStateToProps = (state) => {
  return {
    tournaments: state.misc.tournaments,
    holes: state.scoringInterfaceData.holes,
    selectedTournamentId: state.misc.selectedTournamentId,
    isStableford: state.scoringInterfaceData.isStableford,
    displayOption: state.filters.displayOption,
    courses: state.scoringInterfaceData.courses,
    selectedTee: state.filters.selectedTee,
    selectedCourse: state.filters.selectedCourse,
    sortOrder: state.filters.sortOrder,
    sortOption: state.filters.sortByOption,
    isPortal: state.misc.isPortal,
    rounds: state.misc.rounds,
    showRounds: !!state.misc.rounds,
    roundId: state.misc.roundId,
    showFilters: state.filters.showFilters,
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeDisplayOption: (value) => dispatch(changeDisplayOptionFilter(value)),
  changeTournament: (value) => dispatch(changeTournament(value)),
  changeStartingHole: (value) => dispatch(changeStartingHoleFilter(value)),
  changeCourse: (value) => dispatch(changeCourseFilter(value)),
  changeSortOption: (value) => dispatch(changeSortOption(value)),
  changeSortOrderOption: () => dispatch(changeSortOrderOption()),
  changeRound: (value) => dispatch(changeRound(value)),
  showHideFilters: () => dispatch(showHideFilters()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filters)
